export default "__VITE_ASSET__4QJvZsFC__"